import { createFileRoute } from "@tanstack/react-router";

import { PosthogFormPage } from "~/pages/connection-new/posthog-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/posthog",
)({
  component: PosthogFormPage,
});
